import React, { useEffect, useMemo, useRef, useState } from "react";
import * as axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  setWebsiteByImage,
  setAliexpress,
  setAliexpressImage,
  setAmazon,
  setGoogle,
  setAliexpressI,
  setAmazonI,
  setGoogleI,
  setWebsiteByImageCC,
  setAliexpressICC,
  setGoogleICC,
  setAmazonICC,
  setGoogleMax,
  setWalmart,
  setProductSearch,
} from "../redux/actions/productsActions";
import ProductComponent from "./ProductComponent";
import StoreContainer from "./StoreContainer";
import BasicLoading from "./widgets/BasicLoading";
import TransitionLoading from "./widgets/TransitionLoading";
import { useHistory } from "react-router-dom";
import CompareProduct from "./widgets/CompareProduct";
import Header from "./Header";
import { ProductSearch } from "../additionalFunctions/SearchRecommendations";
import { Event } from "../additionalFunctions/GoogleAnalyticsFunctions";
import {
  FilterAliexpressProducts,
  FilterAmazonProducts,
  FilterGoogleProducts,
} from "../additionalFunctions/ProductsFilter";

const ProductPage = (imageFile) => {
  const history = useHistory();
  function dataNotNull(response) {
    try {
      if (response !== null && response !== undefined) {
        if (response.hasOwnProperty("data")) {
          if ("results" in response.data) {
            if (Array.isArray(response.data.results)) {
              return true;
            }
          }
        }
      }
    } catch (error) {}
    return false;
  }
  const ServerUrl = "https://server-dot-tryshopextension.uc.r.appspot.com/";
  //const ServerUrl = "https://52.87.230.144/";
  //const ServerUrl = "http://localhost:2222/";
  const domain = "pricein.ai";
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const preLoad = useRef();
  const [videOn, setVideoOn] = useState(true);

  const videoRef = useRef(null);
  const videoRef2 = useRef(null);
  const videoRef3 = useRef(null);

  const [preLoading, setPreLoading] = useState(false);
  const [loadingTextChange, setLoadingTextChange] = useState(
    "Searching for products..."
  );
  const [loadingPage, setLoadingPage] = useState(1);
  const [loadingAmazon, setLoadingAmazon] = useState(1);
  const [loadingOther, setLoadingOther] = useState(1);
  const [loadingStoreByImage, setLoadingStoreByImage] = useState(1);
  const [loadingAliexpress, setLoadingAliexpress] = useState(0);
  var LoadingArray = [1, 1, 1, 1];
  var AmountOfResults = useRef(0);
  const dispatch = useDispatch();
  var queryParams = new URLSearchParams(window.location.search);
  const imgOnlyParam = (queryParams.get("imgonly") || "false") == "true";
  const titleParam = (queryParams.get("title") || "face+massager").replace(
    / /g,
    "+"
  );
  var imgSearchDone = useRef(false);
  var amazonProducts = useRef([]);
  var googleProducts = useRef([]);
  var walmartProducts = useRef([]);
  var productSearchProudcts = useRef([]);
  var aliexpressProducts = useRef([]);
  var aliexpressImageProducts = useRef([]);
  var ebayImageProducts = useRef([]);
  const imageSortParam = queryParams.get("sort") || "0";
  const priceParam = queryParams.get("price") || "0";
  const loadParam = queryParams.has("load") ? false : true;
  const ccParam = queryParams.get("cc") || "us";
  const imgParam = queryParams.get("img");

  const imageSortAddOn = "&sort=1&mainImage=" + imgParam;
  var sortNumber = 0;
  if (imgParam == "null") sortNumber = 1;
  const [chooseMethod, setChooseMethod] = useState(loadParam ? sortNumber : 1);

  var sortMethod = useRef(sortNumber);

  const sortBySimilarityScore = (a, b) => {
    return a.similarityScore - b.similarityScore;
  };

  const togglePlay = () => {
    console.log(videOn);
    if (videOn) {
      videoRef.current.pause();
      videoRef2.current.pause();
      videoRef3.current.pause();
    } else {
      videoRef.current.play();
      videoRef2.current.play();
      videoRef3.current.play();
    }
    setVideoOn(!videOn);
  };
  async function convertImageURLToBase64(imageURL) {
    try {
      const response = await fetch(imageURL);
      const blob = await response.blob();
      const base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      return base64String;
    } catch (error) {}
  }

  // Usage example

  async function imgVectorSort(products, mainImage, mainLoader) {
    let b64 = "";
    let orgiginalProducts = products;
    let error = false;
    const serverURL = "https://server-dot-imgvectorserver.ue.r.appspot.com/";
    //const serverURL = "http://localhost:3333/";
    console.log("Starting Sorting");
    console.log(products.length);
    var images = [];

    for (let i = 0; i < products.length; i++) {
      if (products[i].hasOwnProperty("imageUrl")) {
        images.push(products[i].imageUrl);
      } else {
        images.push(products[i].img);
      }
    }
    console.log(images);
    if (mainImage.includes(domain))
      b64 = await convertImageURLToBase64(mainImage);

    try {
      var response = await fetch(serverURL, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ images: images, mainImg: mainImage, b64: b64 }),
      });
      response = await response.json();
      console.log(response);

      for (let i = 0; i < products.length; i++) {
        products[i]["similarityScore"] = response[i]["similarityScore"];
      }

      // Sorting the objects by the 'numb' attribute

      products.sort(sortBySimilarityScore);
    } catch (error) {
      console.log(error);
      error = true;
    }
    console.log("Done sorting");
    if (mainLoader) {
      console.log("Main loader");
      imgSearchDone.current = true;
    }
    return !error ? products : orgiginalProducts;
  }

  const fetchAmazon = async (titleArg, imgTitle) => {
    var fetchURL =
      ServerUrl + "searchByTitle/amazon/?cc=" + ccParam + "&title=" + titleArg;
    //if (imageSortParam != "0") fetchURL = fetchURL + imageSortAddOn;
    var response = await axios.get(fetchURL).catch((err) => {
      console.log("Err: ", err);
    });
    amazonProducts.current = response.data.results;
    if (sortMethod.current == 2 && dataNotNull(response) && imgTitle == 0) {
      console.log("SortMehod" + sortMethod.current);
      response = await imgVectorSort(amazonProducts.current, imgParam, false);
    } else {
      if (dataNotNull(response)) {
        response = response.data.results;
      } else {
        response = [];
      }
    }
    console.log(response);
    if (imgTitle == 0) {
      dispatch(setAmazon(response));
      setLoadingAmazon(0);
    } else if (imgTitle == 1) {
      dispatch(setAmazonI(response));
      setLoadingAmazon(0);
    } else {
      dispatch(setAmazonICC(response));
      setLoadingAmazon(0);
    }
  };
  function removeImageParams(imageUrl, fileExtension) {
    let newImageUrl = imageUrl;
    let index = imageUrl.indexOf(fileExtension);
    if (imageUrl.substr(index, imageUrl.length - index).includes("?")) {
      newImageUrl = imageUrl.substr(0, index + fileExtension.length);
    }
    return newImageUrl;
  }
  function trimImageUrl(imgUrl) {
    let newImageUrl = imgUrl;

    if (imgUrl.includes(".jpg"))
      newImageUrl = removeImageParams(imgUrl, ".jpg");
    else if (imgUrl.includes(".jpeg"))
      newImageUrl = removeImageParams(imgUrl, ".jpeg");
    else if (imgUrl.includes(".webp"))
      newImageUrl = removeImageParams(imgUrl, ".webp");
    else if (imgUrl.includes(".png"))
      newImageUrl = removeImageParams(imgUrl, ".png");
    else if (imgUrl.includes(".gif"))
      newImageUrl = removeImageParams(imgUrl, ".gif");
    else if (imgUrl.includes(".svg"))
      newImageUrl = removeImageParams(imgUrl, ".svg");
    else if (imgUrl.includes(".avif"))
      newImageUrl = removeImageParams(imgUrl, ".avif");
    else if (imgUrl.includes(".apng"))
      newImageUrl = removeImageParams(imgUrl, ".apng");
    else if (imgUrl.includes(".jfif"))
      newImageUrl = removeImageParams(imgUrl, ".jfif");
    else if (imgUrl.includes(".pjepg"))
      newImageUrl = removeImageParams(imgUrl, ".pjepg");
    else if (imgUrl.includes(".pjp"))
      newImageUrl = removeImageParams(imgUrl, ".pjp");
    // console.log(newImageUrl);
    return newImageUrl;
  }

  function formatStoresData(response) {
    var results = [];
    try {
      if (response.hasOwnProperty("data")) {
        if (response.data.hasOwnProperty("links")) {
          const responseData = response.data;
          for (let index = 0; index < responseData.links.length; index++) {
            const link = responseData.links[index];
            const title = responseData.names[index];
            const company = responseData.company[index];
            const img = responseData.images[index];
            results.push({
              link: link,
              title: title,
              company: company,
              img: img,
            });
          }
        }
      }
    } catch (error) {}
    return results;
  }

  const fetchTryDeploy = async () => {
    let response = () => {
      return new Promise(function (resolve, reject) {
        fetch("http://httpbin.org/ip").then((response) => {
          resolve(response);
        });
      });
    };
    let responseData = await response();
    console.log("fetchTryDeploy");
    console.log(responseData.data);
  };

  const fetchTesting = async () => {
    var formattedResponst;
    console.log("Try fetch ip");

    const response = await axios
      .get(
        "https://stackoverflow.com/questions/58913870/get-client-ip-address-from-fetch-response"
      )
      .catch((err) => {
        console.log("Err: ", err);
      });
    console.log("Fetch response");
    console.log(response);
  };

  const fetchWebsitesByImage = async () => {
    var formattedResponst;

    const response = await axios
      .get(
        "https://64pae647vzo3g55h2f3uw4psh40tkhjr.lambda-url.us-east-1.on.aws/" +
          "?url=" +
          trimImageUrl(imgParam)
      )
      .catch((err) => {
        console.log("Err: ", err);
      });
    console.log(response);
    formattedResponst = formatStoresData(response);

    console.log("Formatted Response", formattedResponst);
    dispatch(setWebsiteByImage(formattedResponst));
    setLoadingStoreByImage(0);
    try {
      if (formattedResponst[0].title) {
        const titleparam = formattedResponst[0].title
          .replace(/[\W_]+/g, " ")
          .replace(/ /g, "+");
        console.log("titleparam image", titleparam);
        if (imgOnlyParam) {
          fetchAliexpress(titleparam, 0);
          fetchAmazon(titleparam, 0);
          fetchGoogle(titleparam, 0);
        }
      }
    } catch (error) {}
  };

  const fetchWebsitesByImageCC = async () => {
    var formattedResponst;
    console.log(
      "https://wihl7do3ggohrodqfxarhsdybi0dehjx.lambda-url.us-east-1.on.aws/" +
        "?url=" +
        imgParam +
        "&cc=" +
        ccParam
    );
    const response = await axios
      .get(
        "https://wihl7do3ggohrodqfxarhsdybi0dehjx.lambda-url.us-east-1.on.aws/" +
          "?url=" +
          imgParam +
          "&cc=" +
          ccParam
      )
      .catch((err) => {
        console.log("Err: ", err);
      });

    formattedResponst = formatStoresData(response);

    console.log("Formatted Response", formattedResponst);
    dispatch(setWebsiteByImageCC(formattedResponst));
    setLoadingStoreByImage(0);

    const titleparam = formattedResponst[0].title
      .replace(/[\W_]+/g, " ")
      .replace(/ /g, "+");
    console.log("titleparam image", titleparam);
    fetchAliexpress(titleparam, 2);
    fetchAmazon(titleparam, 2);
    fetchGoogle(titleparam, 2);
  };

  const fetchAliexpress = async (titleArg, imgTitle) => {
    var fetchURL = ServerUrl + "/proxymiddle/aliexpress";
    let data = JSON.stringify({
      target: "root",
      data: { page: 1, g: "y", SearchText: titleParam, origin: "y" },
      eventName: "onChange",
      dependency: [],
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: fetchURL,
      headers: {
        authority: "www.aliexpress.com",
        accept: "*/*",
        "accept-language": "sv-SE,sv;q=0.9,en-US;q=0.8,en;q=0.7",
        "bx-v": "2.5.3",
        "content-type": "application/json;charset=UTF-8",
        cookie:
          'xman_f=NCIqS32G3eMEt3EbZ8hNo/XMK8TRV8/PaoLvvVPEDjkS4vEHLsKnzOegMTMubxfHQrunqnN8qS/5yg+hoZFKotcQ7YqL2/Iz6Swe5BmGZ0YEyBgCXENWpw==; cna=CtW6HLzBUG0CAVrj1UBK8WWG; _ym_uid=1682001229315003799; ali_apache_id=33.27.136.236.1685631868130.174794.1; ali_apache_track=; e_id=pt20; aep_usuc_f=site=glo&c_tp=SEK&ups_d=1|1|1|1&ups_u_t=1701245506818&region=SE&b_locale=en_US&ae_u_p_s=2; account_v=1; _gcl_au=1.1.1981745836.1694506720; aep_history=keywords%5E%0Akeywords%09%0A%0Aproduct_selloffer%5E%0Aproduct_selloffer%091005005440524164%091005005334760723%091005005707095979%091005005351097015%091005005148366473%091005005618168845%091005005795311706%091005005209778740; intl_locale=en_US; acs_usuc_t=x_csrf=1eulyidurobmm&acs_rt=c1f2891f0d4e4cf4a0e0a1bd0f7653db; xman_t=xyNzuqFoYpPTxcnfmFrnJ7JXiSnvv3WzJWCTgF5qS1QB4PVaTPKqYwyPMBFBmCyf; AKA_A2=A; ali_apache_tracktmp=; _m_h5_tk=80e6077451357b02ebde702fd4fdc306_1699711147680; _m_h5_tk_enc=b61ba8dfb6716286544ee5f8c7c429a7; _gid=GA1.2.1001943364.1699709348; xlly_s=1; _fbp=fb.1.1699709348523.860160822; _ym_d=1699709349; _ym_isad=2; _ym_visorc=b; AB_DATA_TRACK=450145_617385; AB_ALG=; AB_STG=st_StrategyExp_1694492533501%23stg_687; aeu_cid=de5d40b498aa41769af3350f2275209f-1699709355591-07790-_ePNSNV; JSESSIONID=033D3606FB1071B410F3318345F2C755; xman_us_f=x_locale=en_US&x_l=0&x_c_chg=0&x_c_synced=0&x_as_i=%7B%22aeuCID%22%3A%22de5d40b498aa41769af3350f2275209f-1699709355591-07790-_ePNSNV%22%2C%22af%22%3A%222075099%22%2C%22affiliateKey%22%3A%22_ePNSNV%22%2C%22channel%22%3A%22AFFILIATE%22%2C%22cv%22%3A%221%22%2C%22isCookieCache%22%3A%22N%22%2C%22ms%22%3A%221%22%2C%22pid%22%3A%22177275576%22%2C%22tagtime%22%3A1699709355591%7D&acs_rt=668f83dcdc3c4dfc8d2a1c47e3885622; intl_common_forever=xzE/hR8aagxyGL0tKprwnqVfCv2pflenRDb3z30qe1cexLTuPnsowg==; cto_bundle=Q-3L-V8zS2tjeHNubWJlTlgxSTJTSXZDNUI0VVZ2b3g4OVgyY3hDUkZiSUExVXVpY1Z0WFoydVNqc0ptJTJCSVo0NCUyQmQ4TkZxeFZDbm5UVW9EcUdtdFl0N3dtUWlkU1c1Qm9yS0s2V1Mxc2gyUU1RVkJPTDBkNzE2V3RkYVFHSVoyaDFnTUlEbTJRSTRoamlhQUlIR0tLYWxyS0ZjU0FyRG91ZTFhd3dQQmJDdU5WVFkydnVSRXNXM3ZpQlFJcWFqbXVmYVdOcGd3a0FlRk1BekVFblNxRUNEYlBQdyUzRCUzRA; _gat=1; _ga=GA1.1.964241887.1685631871; _ga_VED1YSGNC7=GS1.1.1699709348.20.1.1699709464.4.0.0; RT="z=1&dm=aliexpress.com&si=c0459748-4c0f-40aa-b844-f37c54c2e93b&ss=lou324pb&sl=3&tt=53o&obo=1&rl=1&nu=9y8m6cy&cl=2luh"; tfstk=dBLDP7gOsTwIEEBDAxQjubUlGKi8l-_1adUOBNBZ4TW7H-Uv_NcMHp2OBGhfQOWkCtIAurpuQK95WnBxcf4GedXOBdhXrRJ9TEp9gc_Mjp6JBPdvBStWpBzvkm_TSZ_17vHKJ2FXGN_we75reHIXwyd8a23pGItPHhjjJj95fiSO42hWbyT-mGB31ct1Ww3al9OVEyJprsRTcIXohxLkD8BhQoqzYE205_l9zlZ10_1lpFZvaz5..; l=fBExIhCRN_WPM42jBOfZourza77TcIRf_uPzaNbMi9X1tICtTd3-SBZSbXx2p3QLtTfAietPiA7K9dFw8VU3Wx60MGLNIN22Q6p6-iRLS45..; isg=BP39gNVARFMpZeHDyJ6i83dDDF_3mjHsxVcOK79CUtQ49hwoh-v0vZXgoTKw8Umk; currency=SEK; language=sv; region=191',
        origin: "https://www.aliexpress.com",
        referer:
          "https://www.aliexpress.com/w/wholesale-apple-watch-band.html?page=2&g=y&SearchText=apple+watch+band",
        "sec-ch-ua":
          '"Chromium";v="118", "Google Chrome";v="118", "Not=A?Brand";v="99"',
        "sec-ch-ua-mobile": "?0",
        "sec-ch-ua-platform": '"macOS"',
        "sec-fetch-dest": "empty",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "same-origin",
        "user-agent":
          "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.0.0 Safari/537.36",
      },
      data: data,
    };

    var response = await axios.request(config).catch((err) => {
      console.log("Err: ", err);
    });

    console.log("Aliexpress res", response.data);
    response = FilterAliexpressProducts(response.data);
    console.log("filtered aliexpress", response);
    if (response.length > 0) {
      aliexpressProducts.current = response;
      if (imgTitle == 0) {
        dispatch(setAliexpress(response));
        setLoadingAliexpress(0);
      } else if (imgTitle == 1) {
        dispatch(setAliexpressI(response));
        setLoadingAliexpress(0);
      } else {
        dispatch(setAliexpressICC(response));
        setLoadingAliexpress(0);
      }
    }
  };

  const fetchEbayByImage = async () => {
    const Results = [];
    var response = await axios
      .get(
        "https://y2ves2ixhcpirb2nu2mjg66tju0cqefi.lambda-url.us-east-1.on.aws/" +
          "?ebay=1&url=" +
          trimImageUrl(imgParam)
      )
      .catch((err) => {
        console.log("Err: ", err);
      });
    try {
      if (response.data) {
        response = response.data;
        for (var i = 0; i < response.length; i++) {
          Results[i] = {
            price: response[i].price,
            title: response[i].title,
            img: response[i].image,
            link: response[i].link,
            review: response[i].rating,
          };
        }

        ebayImageProducts.current = Results;
        if (sortMethod.current == 2 && Results.length > 0) {
          console.log("Ebay start");
          response = await imgVectorSort(
            ebayImageProducts.current,
            imgParam,
            true
          );
          console.log("ImgVectorSort done", response);
        } else {
          if (Results.length > 0) {
            response = Results;
          } else {
            response = [];
          }
        }
        console.log("EbayImage object: ", response);
        dispatch(setGoogleICC(response));
        setLoadingOther(0);
      }
    } catch (error) {}
  };

  const fetchAliexpressImage = async () => {
    console.log("Fetch Aliexpress Image");
    var fetchURL =
      ServerUrl + "searchByImage/aliexpress/?img=" + trimImageUrl(imgParam);
    // if (imageSortParam != "0") fetchURL = fetchURL + imageSortAddOn;
    var response = await axios.get(fetchURL).catch((err) => {
      console.log("Err: ", err);
    }); /*
    console.log("Fetch Aliexpress Image");
    const response = await axios
      .get(
        "https://y2ves2ixhcpirb2nu2mjg66tju0cqefi.lambda-url.us-east-1.on.aws/" +
          "?url=" +
          trimImageUrl(imgParam)
      )
      .catch((err) => {
        console.log("Err: ", err);
      });*/
    console.log(response);
    aliexpressImageProducts.current = response.data.results;
    if (sortMethod.current == 2 && dataNotNull(response)) {
      console.log("SortMehod" + sortMethod.current);
      response = await imgVectorSort(
        aliexpressImageProducts.current,
        imgParam,
        false
      );
      console.log("ImgVectorSort done", response);
    } else {
      if (dataNotNull(response)) {
        response = response.data.results;
      } else {
        response = [];
      }
    }

    dispatch(setAliexpressImage(response));
    setLoadingAliexpress(0);
  };

  const fetchGoogleMinMax = async (titleArg, priceMax) => {
    var ccGoogle = ccParam;
    console.log("Price:" + priceMax.replace(/\D/g, ""));
    const response = await axios
      .get(
        ServerUrl +
          "searchByTitle/google/?cc=" +
          ccGoogle +
          "&title=" +
          titleArg +
          "&priceMax=" +
          priceMax.replace(/\D/g, "")
      )
      .catch((err) => {
        console.log("Err: ", err);
      });
    console.log("GoogleMax", response);

    if (dataNotNull(response)) {
      dispatch(setGoogleMax(response.data.results));
      setLoadingOther(0);
    }
  };

  const fetchGoogle = async (titleArg, imgTitle) => {
    var ccGoogle = imgTitle == 1 ? "us" : ccParam;
    var fetchURL =
      ServerUrl + "searchByTitle/google/?cc=" + ccGoogle + "&title=" + titleArg;
    // if (imageSortParam != "0") fetchURL = fetchURL + imageSortAddOn;
    var response = await axios.get(fetchURL).catch((err) => {
      console.log("Err: ", err);
    });
    googleProducts.current = response.data.results;
    if (sortMethod.current == 2 && dataNotNull(response) && imgTitle == 0) {
      console.log("IMG compare google");
      response = await imgVectorSort(googleProducts.current, imgParam, true);
      console.log("ImgVectorSort done", response);
    } else {
      if (dataNotNull(response)) {
        response = response.data.results;
      } else {
        response = [];
      }
    }

    console.log(response);
    if (imgTitle == 0) {
      console.log("Setting google");
      dispatch(setGoogle(response));
      setLoadingOther(0);
    } else if (imgTitle == 1) {
      dispatch(setGoogleI(response));
      setLoadingOther(0);
    } else {
      dispatch(setGoogleICC(response));
      setLoadingOther(0);
    }
  };

  const fetchGoogleUpdated = async (title, imgTitle) => {
    console.log("fetchGoogleUpdated");

    const maxRetries = 3; // Adjust as needed
    let retries = 0;

    const makeRequest = async () => {
      var proxyPath =
        ccParam.toLowerCase() == "us"
          ? "/proxymiddle/google/usa"
          : "/proxymiddle/google";
      var fetchURL = ServerUrl + proxyPath + "?q=" + title + "&cc=" + ccParam;
      console.log("fetchURL", fetchURL);

      try {
        var response = await axios.get(fetchURL, {
          timeout: 10000, // 5 seconds timeout, adjust as needed
        });

        console.log(response.data);
        response = FilterGoogleProducts(response.data);

        if (response.length > 0) {
          googleProducts.current = response.results;
          console.log(response);

          if (imgTitle == 0) {
            console.log("Setting google");
            dispatch(setGoogle(response));
            setLoadingOther(0);
          } else if (imgTitle == 1) {
            dispatch(setGoogleI(response));
            setLoadingOther(0);
          } else {
            dispatch(setGoogleICC(response));
            setLoadingOther(0);
          }
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // Request was canceled due to timeout
          console.log("Request timed out, retrying...");
          retries++;

          if (retries <= maxRetries) {
            // Retry the request
            return makeRequest();
          } else {
            console.error("Max retries reached");
          }
        } else {
          // Handle other errors
          console.error("Error:", error.message);
        }
      }
    };
    makeRequest();
  };

  async function blobImage() {
    if (imgParam.includes("blob:")) {
      const fileInput = document.getElementById("image-input");

      const blobURL = trimImageUrl(imgParam);
      console.log(blobURL);
      const imgResponse = await fetch(blobURL);
      if (!imgResponse.ok) {
      }

      const blob = await imgResponse.blob();

      // Create a Blob object with the binary data and image MIME type
      const imageBlob = new Blob([blob], { type: "image/png" });

      // Create a URL for the Blob
      return imageBlob;
    } else {
      var response = await fetch(ServerUrl + "/blobimage?url=" + imgParam);

      console.log(response);
      const blob = await response.blob();

      // Create a Blob object with the binary data and image MIME type
      const imageBlob = new Blob([blob], { type: "image/png" });
      return imageBlob;
    }
  }

  const fetchProductSearch = async () => {
    let response;
    try {
      const imageBlob = await blobImage();
      response = await ProductSearch(imageBlob);
      console.log(response);
      // Now, 'imageURL' can be used to display or download the image.

      if (sortMethod.current == 2) {
        console.log("IMG Product Search");
        response = await imgVectorSort(walmartProducts.current, imgParam, true);
        console.log("Product Search done", response);
      } else {
        if (response === null || response === undefined) {
          response = [];
        }
      }
      console.log(response);
      console.log("Setting Product Search");
      dispatch(setProductSearch(response));
      setLoadingStoreByImage(0);
      const titleparam = response[0].title
        .replace(/[\W_]+/g, " ")
        .replace(/ /g, "+");
      console.log("titleparam image", titleparam);
      if (imgOnlyParam && imgParam.includes("blob:")) {
        fetchAliexpress(titleparam, 0);
        fetchAmazon(titleparam, 0);
        fetchGoogle(titleparam, 0);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchWalmart = async (titleArg) => {
    var fetchURL = ServerUrl + "searchByTitle/walmart/?title=" + titleArg;
    var response = await axios.get(fetchURL).catch((err) => {
      console.log("Err: ", err);
    });
    walmartProducts.current = response.data.results;
    if (sortMethod.current == 2) {
      console.log("IMG Walmart");
      response = await imgVectorSort(walmartProducts.current, imgParam, true);
      console.log("Walmart ImgVectorSort done", response);
    } else {
      if (dataNotNull(response)) {
        response = response.data.results;
      } else {
        response = [];
      }
    }

    console.log(response);

    console.log("Setting walmart");
    dispatch(setWalmart(response));
    setLoadingOther(0);
  };

  function imgSortAllProducts() {
    if (googleProducts.current.length != 0) {
      console.log("Imgsearching google");
      dispatch(setGoogle([]));
      imgVectorSort(googleProducts.current, imgParam, true)
        .then((result) => {
          console.log("Google ImgVectorSort done", result);
          dispatch(setGoogle(result));
          setLoadingOther(-1);
        })
        .catch((err) => {
          console.log("Google gVectorSort error", err);
          dispatch(setGoogle(googleProducts.current, imgParam));
          setLoadingOther(-1);
        });
    }
    if (amazonProducts.current.length != 0) {
      dispatch(setAmazon([]));
      imgVectorSort(amazonProducts.current, imgParam, false)
        .then((result) => {
          console.log("Amazon ImgVectorSort done", result);
          dispatch(setAmazon(result));
          setLoadingAmazon(-1);
        })
        .catch((err) => {
          console.log("Amazon ImgVectorSort error", err);
          dispatch(setAmazon(amazonProducts.current));
          setLoadingAmazon(-1);
        });
    }
    if (aliexpressProducts.current.length != 0) {
      dispatch(setAliexpress([]));
      imgVectorSort(aliexpressProducts.current, imgParam, false)
        .then((result) => {
          console.log("Aliexpress ImgVectorSort done", result);
          dispatch(setAliexpress(result));
          setLoadingAliexpress(0);
        })
        .catch((err) => {
          console.log("Aliexpress ImgVectorSort error", err);
          dispatch(setAliexpress(aliexpressProducts.current));
          setLoadingAliexpress(0);
        });
    }
    if (aliexpressImageProducts.current.length != 0) {
      dispatch(setAliexpressImage([]));
      imgVectorSort(aliexpressImageProducts.current, imgParam, false)
        .then((result) => {
          console.log("Aliexpress ImgVectorSort done", result);
          dispatch(setAliexpressImage(result));
          setLoadingAliexpress(0);
        })
        .catch((err) => {
          console.log("Aliexpress ImgVectorSort error", err);
          dispatch(setAliexpressImage(aliexpressImageProducts.current));
          setLoadingAliexpress(0);
        });
    }
    if (ebayImageProducts.current.length != 0) {
      console.log("Ebay start");
      dispatch(setGoogleICC([]));
      imgVectorSort(ebayImageProducts.current, imgParam, true)
        .then((result) => {
          console.log("Ebay ImgVectorSort done", result);
          dispatch(setGoogleICC(result));
          setLoadingOther(-1);
        })
        .catch((err) => {
          console.log("Ebay ImgVectorSort error", err);
          dispatch(setGoogleICC(ebayImageProducts.current));
          setLoadingOther(-1);
        });
    }
    if (walmartProducts.current.length != 0) {
      console.log("IMG Walmart start");
      dispatch(setWalmart([]));
      imgVectorSort(walmartProducts.current, imgParam, true)
        .then((result) => {
          console.log("Walmart ImgVectorSort done", result);
          dispatch(setWalmart(result));
          setLoadingOther(-1);
        })
        .catch((err) => {
          console.log("Walmart ImgVectorSort error", err);
          dispatch(setWalmart(walmartProducts.current));
          setLoadingOther(-1);
        });
    }
    if (productSearchProudcts.current.length != 0) {
      console.log("IMG Product Search start");
      dispatch(setProductSearch([]));
      imgVectorSort(productSearchProudcts.current, imgParam, true)
        .then((result) => {
          console.log("Product Search ImgVectorSort done", result);
          dispatch(setProductSearch(result));
          setLoadingOther(-1);
        })
        .catch((err) => {
          console.log("Product Search ImgVectorSort error", err);
          dispatch(setProductSearch(productSearchProudcts.current));
          setLoadingOther(-1);
        });
    }
  }

  function loadingHeaderWhite() {
    const menuItemStyle = document.getElementsByClassName("menu")[0].style;
    const logoStyle = document.getElementsByClassName("logo-text")[0].style;
    const inputStyle = document.getElementsByClassName("box")[0].style;
    menuItemStyle.background = "#fff";
    menuItemStyle.boxShadow = "none";
    logoStyle.color = "#375bd2";
    inputStyle.border = "none";
  }
  function loadingHeaderNomrmal() {
    if (!mobileMode) {
      const menuItemStyle = document.getElementsByClassName("menu")[0].style;
      const logoStyle = document.getElementsByClassName("logo-text")[0].style;
      const inputStyle = document.getElementsByClassName("box")[0].style;
      menuItemStyle.background = "#fff";
      menuItemStyle.boxShadow = "box-shadow: 0px 1px 2px rgb(0 0 0 / 10%);";
      logoStyle.color = "#1967b2";
      inputStyle.border = "1px solid rgba(0, 0, 0, 0.2);";
    }
  }
  let SearchingTextChangeBool = useRef(false);
  async function SearchingTextChange() {
    SearchingTextChangeBool.current = true;
    console.log("Runnning Text Animation");
    const text = [
      "Remember to filter for the lowest price....",
      "Our AI is soon done...",
      "Searching for products...",
    ];
    for (let x = 0; x < 2; x++) {
      for (let i = 0; i < text.length; i++) {
        await delay(3020);

        setLoadingTextChange(text[i]);
      }
    }
  }

  LoadingArray = loadingPage
    ? [loadingAmazon, loadingOther, loadingAliexpress, loadingStoreByImage]
    : [0, 0, 0, 0];
  /*
   */

  const DeleteLoadParam = () => {
    queryParams.delete("load");
    history.replace({
      search: queryParams.toString(),
    });
    LoadingArray = [0, 0, 0, 0];
  };

  const getBrowser = () => {
    const userAgent = navigator.userAgent;
    let browserName = "";

    if (userAgent.indexOf("Edge") > -1) {
      browserName = "Edge";
    } else if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
      browserName = "Safari";
    } else {
      browserName = "Chrome";
    }

    return browserName;
  };

  const browser = getBrowser();

  const mobileWidth = 1000;
  // const [mobileMode, setMobileMode] = useState(window.innerWidth < mobileWidth);
  const [mobileMode, setMobileMode] = useState(window.innerWidth < mobileWidth);
  let haveSetMobileMode = window.innerWidth < mobileWidth;
  const handleResize = () => {
    if (window.innerWidth < mobileWidth && !haveSetMobileMode) {
      setMobileMode(true);
      haveSetMobileMode = true;
      console.log("Setting mobile mode to", true);
    } else if (window.innerWidth > mobileWidth && haveSetMobileMode) {
      setMobileMode(false);
      haveSetMobileMode = false;
      console.log("Setting mobile mode to", false);
    }
  };
  function sendPsEvent() {
    const eventData =
      "title= " + titleParam.replace(/\+/g, " ") + " image= " + imgParam;
    const eventCatygory =
      imgParam && titleParam
        ? "title & image"
        : titleParam
        ? "title only"
        : "image only";
    Event("Search by " + eventCatygory, "Product Search", eventData, eventData);
  }
  useEffect(() => {
    sendPsEvent();
    window.addEventListener("resize", handleResize);
    if (loadParam) {
      if (!imgOnlyParam) {
        //loadingHeaderWhite();
        document.title = titleParam.replace(/\+/g, " ");
        setLoadingPage(true);
        // fetchAmazon(titleParam, 0);

        fetchGoogleUpdated(titleParam, 0);
        fetchAmazon(titleParam, 0);
        fetchAliexpress(titleParam, 0);
        if (imgParam != "null") {
          fetchAliexpressImage();
          fetchWebsitesByImage();
          if (ccParam.toLowerCase() == "us") fetchEbayByImage();
        }
        if (ccParam.toLowerCase() == "us") fetchWalmart(titleParam);

        // fetchGoogleMinMax(titleParam, priceParam);

        //fetchWebsitesByImageCC();
      } else {
        setLoadingPage(true);
        fetchProductSearch();
        if (!imgParam.includes("blob:")) {
          fetchAliexpressImage();
          fetchEbayByImage();
          fetchWebsitesByImage();
        }
        document.title = "Image Search";
      }
    } else {
      DeleteLoadParam();
      setLoadingPage(false);
      setPreLoading(true);
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  var amountOfProducts =
    chooseMethod == 2
      ? amazonProducts.current.length +
          googleProducts.current.length +
          ebayImageProducts.current.length >=
        8
      : true;

  if (!imgOnlyParam && amountOfProducts) {
    delay(0).then(() => {
      if (sortMethod.current == 2) {
        if (imgSearchDone.current) {
          console.log("Loading 2");
          if (
            imgSearchDone.current &&
            document.querySelector(".progress-fill")
          ) {
            console.log("Playing finished animation");
            var progressBar =
              document.getElementsByClassName("progress-fill")[0];
            progressBar.style.animationName = "last-progress";
            progressBar.style.animationDuration = "1s";
            progressBar.style.animationIterationCount = "1";
            delay(1000).then(() => {
              setPreLoading(true);
              loadingHeaderNomrmal();
            });
          } else {
            setPreLoading(true);
            loadingHeaderNomrmal();
          }
        }
      }
      if (
        (sortMethod.current == 1 && loadingOther == 0) ||
        loadingAmazon == 0
      ) {
        console.log("Loading 1");
        setPreLoading(true);
        loadingHeaderNomrmal();
      }
    });
  }
  if (imgOnlyParam && loadingStoreByImage == 0) {
    delay(0).then(() => {
      setPreLoading(true);
      // loadingHeaderNomrmal();
    });
  }
  /*
  delay(0).then(() => {
    console.log("Loading 1");
    setPreLoading(true);
    // loadingHeaderNomrmal();
  });*/

  if (
    sortMethod.current == 1 &&
    !preLoading &&
    !SearchingTextChangeBool.current
  ) {
    if (document.getElementsByClassName("store-container").length == 0) {
      SearchingTextChange();
    }
  }

  return (
    <>
      <Header mobileMode={mobileMode} />
      <div className="product-container">
        {chooseMethod || imgOnlyParam ? (
          <>
            {true ? (
              <>
                <StoreContainer
                  loading={loadParam ? LoadingArray : [1, 0, 0]}
                  mobileMode={mobileMode}
                />
                <ProductComponent mobileMode={mobileMode} />
              </>
            ) : (
              <>
                {sortMethod.current == 1 ? (
                  <div className="regular-loading-container">
                    <TransitionLoading></TransitionLoading>
                    <div className="preloading-text typing-demo">
                      {loadingTextChange}
                    </div>
                  </div>
                ) : (
                  <>
                    {!mobileMode ? (
                      <>
                        <div className="serchbyimage-content-title progress-title">
                          Loading Products...
                        </div>
                        <div className="progress-body">
                          <div className="progress-div">
                            <div className="progress-bar">
                              <div class="progress-fill"></div>
                            </div>
                          </div>
                          <div className="storesByImageTitle how-to-tips">
                            <span className="title-section-stores-by-title">
                              Searching
                            </span>
                            <span className="title-section-stores-by-title">
                              tips
                            </span>
                          </div>
                          <div className="progress-tutorial-vids">
                            <div className="progress-vid-obj">
                              <div className="serchbyimage-content-title prog-vid-title">
                                Sort by price
                              </div>
                              <div className="searchbyimage-video-body">
                                <img
                                  src="/images/Sortafter.webp"
                                  alt="image of sort after method"
                                ></img>
                              </div>
                            </div>
                            <div className="progress-vid-obj">
                              <div className="serchbyimage-content-title prog-vid-title">
                                Search By Image
                              </div>
                              <div className="searchbyimage-video-body">
                                <video
                                  ref={videoRef2}
                                  class="tutorial-video-searchby"
                                  autoPlay
                                  muted
                                  playsInline
                                  loop
                                >
                                  <source
                                    src="/images/FindByImage.mp4"
                                    type="video/mp4"
                                  />
                                </video>
                                <span
                                  class="video-on-off-searchbyimage"
                                  onClick={togglePlay}
                                >
                                  {videOn && (
                                    <svg
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                      fill="white"
                                      xmlns="http://www.w3.org/2000/svg"
                                      aria-hidden="true"
                                    >
                                      <g clip-path="url(#clip0_2_213)">
                                        <circle
                                          cx="16"
                                          cy="16"
                                          r="15"
                                          stroke="#565B6C"
                                          stroke-width="2"
                                        ></circle>
                                        <rect
                                          x="20"
                                          y="10"
                                          width="12"
                                          height="2"
                                          rx="1"
                                          transform="rotate(90 20 10)"
                                          fill="#565B6C"
                                        ></rect>
                                        <rect
                                          x="14"
                                          y="10"
                                          width="12"
                                          height="2"
                                          rx="1"
                                          transform="rotate(90 14 10)"
                                          fill="#565B6C"
                                        ></rect>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_2_213">
                                          <rect
                                            width="32"
                                            height="32"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  )}
                                  {!videOn && (
                                    <svg
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                      fill="white"
                                      xmlns="http://www.w3.org/2000/svg"
                                      aria-hidden="true"
                                    >
                                      <g clip-path="url(87489656-c327-45fb-9b94-d0dd4ddf69d1)">
                                        <circle
                                          cx="16"
                                          cy="16"
                                          r="15"
                                          stroke="#565B6C"
                                          stroke-width="2"
                                        ></circle>
                                        <path
                                          d="M21.7003 15.1601C22.31 15.5541 22.31 16.4459 21.7003 16.8399L14.234 21.6648C13.5686 22.0948 12.6913 21.6172 12.6913 20.825L12.6913 11.175C12.6913 10.3828 13.5686 9.90516 14.234 10.3352L21.7003 15.1601Z"
                                          fill="#565B6C"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="87489656-c327-45fb-9b94-d0dd4ddf69d1">
                                          <rect
                                            width="32"
                                            height="32"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="serchbyimage-content-title progress-title"
                          style={{ color: "#000" }}
                        >
                          Loading Products...
                        </div>
                        <div className="progress-body">
                          <div className="progress-div">
                            <div
                              className="progress-bar"
                              style={{
                                height: "15px",
                                width: "80%",
                              }}
                            >
                              <div
                                class="progress-fill"
                                style={{
                                  background: "#1967D2",
                                  height: "15px",
                                }}
                              ></div>
                            </div>
                          </div>

                          <div
                            className="tip-container"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              marginTop: "80px",
                            }}
                          >
                            <div
                              className="serchbyimage-content-title prog-vid-title"
                              style={{ color: "#333" }}
                            >
                              Tip: sort by match, price, reviews etc
                            </div>
                            <div className="searchbyimage-video-body">
                              <img
                                src="/images/Sortafter.webp"
                                alt="image of sort after method"
                              ></img>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            {true ? (
              <>
                <StoreContainer
                  loading={loadParam ? LoadingArray : [1, 0, 0]}
                  mobileMode={mobileMode}
                />
                <ProductComponent mobileMode={mobileMode} />
              </>
            ) : (
              <div className="choose-method-obj">
                <div
                  className="choose-method-text content-subject-title"
                  style={{ color: "#212121" }}
                >
                  Choose Method
                </div>

                <div className="choose-buttons-container">
                  <div className="choose-btncon">
                    <div className="choose-btn-text">ca 5 seconds</div>
                    <button
                      className="downolad-extension-button choose-btn"
                      onClick={() => {
                        console.log("clicked btn");
                        setChooseMethod(1);
                        sortMethod.current = 1;
                      }}
                    >
                      Regular search
                    </button>
                  </div>
                  <div className="choose-btncon">
                    <div className="choose-btn-text">
                      ca 15 seconds (Recommended)
                    </div>
                    <button
                      className="downolad-extension-button choose-btn"
                      style={{ background: "#375BD2", color: "white" }}
                      onClick={() => {
                        setChooseMethod(2);
                        sortMethod.current = 2;
                        console.log("ChooseMethod", sortMethod.current);
                        imgSortAllProducts();
                      }}
                    >
                      Accourate search
                    </button>
                  </div>
                </div>
              </div>
            )}{" "}
          </>
        )}
      </div>
    </>
  );
};

export default ProductPage;
